import React, { useState, useEffect } from 'react'
import './SleeveEditor.css'
import HoldingsEditor from '../HoldingsEditor/HoldingsEditor'
import { useSelector, useDispatch } from 'react-redux'
import { saveSleeve } from '../../../actions/data'
import i18n from '../../../i18n'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';




const SleeveEditor = () => {
  const dispatch = useDispatch()
  const models = useSelector(state => state.data.models)
  const selectedApproach = useSelector(state => state.data.selectedApproach)
  const clientEmail = useSelector(state => state.params.params.clientEmail)

  const modelsFilteredByApproach = models
    ? models.filter(item => item.modelFamily === selectedApproach)
    : []
  const [swappedTickers, setSwappedTickers] = useState([])
  const [consolidatedTickersByAssetClass, setConsolidatedTickersByAssetClass] = useState(
    []
  )

  useEffect(() => {
    let tickerDetails = []
    let processedTickers = new Set()
    let assetClasses = new Set()

    modelsFilteredByApproach.forEach(modelItem => {
      modelItem.holdings.forEach(modelHoldings => {
        modelHoldings.tickers.forEach((ticker, tickerIndex) => {
          if (!processedTickers.has(ticker)) {
            processedTickers.add(ticker)
            let tickerInfo = {}
            tickerInfo['ticker'] = ticker
            tickerInfo['name'] = modelHoldings.names[tickerIndex]
            tickerInfo['wtCategory'] = modelHoldings.wtCategories[tickerIndex]
            tickerInfo['assetClass'] = modelHoldings.assetClasses[tickerIndex]
            assetClasses.add(modelHoldings.assetClasses[tickerIndex])
            tickerDetails.push(tickerInfo)
          }
        })
      })
    })

    let finalTickerDetails = []
    assetClasses.forEach(assetClass => {
      let assetClassInfo = {}
      assetClassInfo['assetClass'] = assetClass
      assetClassInfo['data'] = tickerDetails.filter(
        item => item['assetClass'] === assetClass
      )
      finalTickerDetails.push(assetClassInfo)
    })

    setConsolidatedTickersByAssetClass(finalTickerDetails)
  }, [])

  const handleSaveSleeve = async () => {
    let saveData = {}
    saveData['clientEmail'] = clientEmail
    saveData['timestamp'] = null
    saveData['swaps'] = swappedTickers
    dispatch(saveSleeve(saveData))
    window.scrollTo(141, 865)
  }

  if (consolidatedTickersByAssetClass.length === 0) return null

  // console.log('consolidatedTickersByAssetClass', consolidatedTickersByAssetClass)
  return (
    <div className='sleeve-editor'>
      <div className='sleeve-editor-title'> {selectedApproach}  APPROACH  </div>
      <div className='sleeve-editor-subtitle'>Would you like to make any fund modifications? You can use the <FontAwesomeIcon icon={faEdit} size='sm' />  icon to swap out a ticker.</div>
      <HoldingsEditor
        sleeveTickers={consolidatedTickersByAssetClass}
        sleeveFamilyName={selectedApproach}
        setSwappedTickers={setSwappedTickers}
        swappedTickers={swappedTickers}
      />
      <div className='action-buttons'>
        <button onClick={handleSaveSleeve}>{i18n.t('next1')}</button>
      </div>
    </div>
  )
}

export default SleeveEditor